import { z } from "zod";
import { timestampSchema } from "../smart-views/schemas";

export const smartContextRecordSchema = z.object({
  id: z.string(),
  associated_space_account_id: z.string(),
  payload_json: z.unknown().nullable(),
  created_at: timestampSchema,
  updated_at: timestampSchema,
});

export const smartContextUpsertSchema = z.object({
  id: z.string(),
  associated_space_account_id: z.string(),
  payload_json: z.unknown().optional(),
  created_at: timestampSchema.optional(),
  updated_at: timestampSchema.optional(),
});

export type SmartContextRow = z.infer<typeof smartContextRecordSchema>;
export type SmartContextUpsertInput = z.input<typeof smartContextUpsertSchema>;
